import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import MoviePage from "@/pages/movie/page";
import TvPage from "@/pages/tv/page";
import NewsPage from "@/pages/news/page";
import SpecialPage from "@/pages/special/page";
import DetailPage from "@/pages/detail/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "movie", element: <MoviePage /> },
      { path: "tv", element: <TvPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "special", element: <SpecialPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;